var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from "mobx";
import { ParameterizedRemoteData } from "../Infra/RemoteData";
export class PatientPreferencesManager {
    constructor(authManager, patientService, invalidationManager) {
        this.authManager = authManager;
        this.patientService = patientService;
        this.invalidationManager = invalidationManager;
        this.preferences = new ParameterizedRemoteData(this.invalidationManager, () => [this.authManager.orgId, this.authManager.id, this.authManager.userType], () => this.loadPreferences());
        this.preferencesWithContacts = new ParameterizedRemoteData(this.invalidationManager, () => [this.authManager.orgId, this.authManager.id, this.authManager.userType, "withContacts"], () => this.loadPreferencesWithContacts());
    }
    async loadPreferences() {
        const userId = this.authManager.id;
        const userType = this.authManager.userType;
        if (userType === "PATIENT" && userId) {
            return await this.patientService.getPatientPreferences(userId);
        }
        else {
            return null;
        }
    }
    async loadPreferencesWithContacts() {
        const userId = this.authManager.id;
        const userType = this.authManager.userType;
        if (userType === "PATIENT" && userId) {
            return await this.patientService.getPatientPreferences(userId, true);
        }
        else {
            return null;
        }
    }
    async updatePatientPreferences(preferences) {
        if (this.authManager.userType === "PATIENT" && this.authManager.id) {
            await this.patientService.updatePatientPreferences(this.authManager.id, preferences);
            await this.preferences.waitForReload();
            await this.preferencesWithContacts.waitForReload();
        }
    }
    async setPrimaryEmail(emailId) {
        if (this.authManager.userType === "PATIENT" && this.authManager.id) {
            await this.patientService.setPrimaryEmail(this.authManager.id, emailId);
            await this.preferences.waitForReload();
            await this.preferencesWithContacts.waitForReload();
        }
    }
    async setPrimaryPhone(phoneId) {
        if (this.authManager.userType === "PATIENT" && this.authManager.id) {
            await this.patientService.setPrimaryPhone(this.authManager.id, phoneId);
            await this.preferences.waitForReload();
            await this.preferencesWithContacts.waitForReload();
        }
    }
}
__decorate([
    observable
], PatientPreferencesManager.prototype, "preferences", void 0);
__decorate([
    observable
], PatientPreferencesManager.prototype, "preferencesWithContacts", void 0);
